<template>
  <nav-bar title="通知" :hasBack="false" />
  <Content bottom="0">
    <ul class="list">
      <li
        class="list-item"
        v-for="item in list"
        :key="item.nid"
        @click="handleNoticeClice(item)"
      >
        <p>{{ item.ntitle }}</p>
        <div class="desc">
          <span>下发单位：{{ item.npublicDept }}</span>
          <span>下发时间：{{ item.npublicTime }}</span>
        </div>
      </li>
    </ul>
  </Content>
  <Popup title="通知内容" ref="popup" minHeight="100%">
    <div class="notice-content">
      <p>{{ content }}</p>
      <p><van-button
        style="margin: 0 auto"
        type="primary"
        size="small"
        @click="handleReadClick"
        >已阅</van-button
      >
      </p>
    </div>
  </Popup>
</template>

<script>
import { ref } from 'vue'
import { Toast } from 'vant'
import { useGetData } from '@/hooks/useGetData'
import { getNoticeList, read } from '@/api/welcome'
import { useRouter } from 'vue-router'
export default {
  name: 'Notice',
  props: ['role', 'username'],
  setup(props) {
    const router = useRouter()
    const list = ref([])
    const getList = () => {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: '请稍等..'
      })
      useGetData(
        getNoticeList,
        data => {
          list.value = data
          if (!data.length) {
            router.push({ path: '/welcome', query: { notice: 0 } })
          }
          Toast.clear()
        },
        () => Toast.clear()
      )({ roleId: props.role, username: props.username })
    }
    getList()
    const popup = ref(null)
    const content = ref('')
    const nid = ref('')
    const handleNoticeClice = value => {
      content.value = value.ncontent
      nid.value = value.nid
      popup.value.show = true
    }

    const handleReadClick = () => {
      useGetData(read, data => {
        popup.value.show = false
        getList()
      })({ id: nid.value, username: props.username })
    }
    return { list, handleNoticeClice, popup, content, handleReadClick }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    background-color: #fff;
    padding: 5px 16px;
    margin-top: 16px;
    border-radius: 5px;
    p {
      margin: 0;
      line-height: 28px;
      font-weight: 600;
    }
    .desc {
      color: #666;
      font-size: 12px;
      span {
        margin-right: 10px;
      }
    }
  }
}
.notice-content {
  font-size: 14px;
  line-height: 26px;
  color: #333;
  padding: 16px;
}
</style>
